import NewselaGlobalLayout from "@/base";
import NotLoggedInError from "@/errors/NotLoggedInError";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const withAccountSettingsPrivileges = (ComponentToWrap) => {
  const WrappedWithApprovedAdmin = () => {
    const { data: user } = useUser();
    const { isAuthenticatedUser } = getUserProperties(user);

    if (!isAuthenticatedUser)
      return <NewselaGlobalLayout mainContents={<NotLoggedInError />} />;
    return <ComponentToWrap />;
  };

  return WrappedWithApprovedAdmin;
};

export default withAccountSettingsPrivileges;
